<template>
  <nav class="w-full bg-navbar">
    <div class="lg:container lg:h-16 lg:px-6 lg:mx-auto flex flex-wrap justify-between items-center">
      <div class="lg:w-2/5 w-full pl-4 lg:pl-0 py-2 lg:py-0 w-full flex justify-between px-2 lg:px-0">
        <router-link to="/">
          <img class="pt-3 pb-1" src="@/assets/img/Dashboard/logo-azul-sin-fondo.png" alt="logo nirex" width="100" />
        </router-link>
      </div>
      <div class="w-3/5 h-full hidden lg:flex justify-between lg:items-baseline">
        <router-link class="flex px-8 md:px-0 py-2 md:py-0 no-underline font-neue nav-link text-base link-visted"
          to="/dashboard">
          <span class="pl-2">SERVICIOS</span>
        </router-link>
        <router-link class="flex py-3 px-4 md:px-0 md:py-0 no-underline font-neue nav-link text-base link-visted"
          to="/dashboard/tracking">
          <span class="pl-2">STATUS</span>
        </router-link>
        <router-link class="flex py-3 px-4 md:px-0 md:py-0 no-underline font-neue nav-link text-base link-visted"
          to="/dashboard/reports">
          <span class="pl-2">HISTORIAL</span>
        </router-link>
        <!-- <router-link class="flex py-3 px-4 md:px-0 md:py-0 no-underline font-neue nav-link text-base link-visted"
          to="/integration">
          <span class="pl-2">INTEGRACIONES</span>
        </router-link> -->
        <!-- <router-link
          class="flex py-3 px-4 md:px-0 md:py-0 no-underline uppercase font-neue nav-link text-sm"
          to="/dashboard/charts"
        >
          <img
            class="w-4 h-4 report__icon"
            src="https://s3-sa-east-1.amazonaws.com/nirex2.0/Web+app/App_clientes/assets/Dashboard/iconos-mobile/m-reportes.svg"
            alt="charts"
          />
          <span class="pl-2">Reportes</span>
        </router-link> -->
        <router-link
          class="h-full group relative flex py-3 px-4 md:px-0 md:py-0 no-underline font-neue nav-link text-base items-center link-visted"
          to="/dashboard/profile">
          <span class="pl-2">CUENTA</span>
          <div class="top-full group-hover hidden absolute pin-r w-full bg-green-neon text-center py-2 z-50">
            <a class="text-white no-underline uppercase" @click="logout">Salir</a>
          </div>
        </router-link>
      </div>
      <div class="w-full flex lg:hidden bg-block-purple text-primary h-16 py-4">
        <router-link class="flex-1 flex justify-center" to="/dashboard">
          <img src="@/assets/img/Icons/servicios.png" alt="nueva orden" />
        </router-link>
        <router-link class="flex-1 flex justify-center" to="/dashboard/tracking">
          <img src="@/assets/img/Icons/status.png" alt="tracking" />
        </router-link>
        <!-- <router-link class="flex-1 flex justify-center" to="/dashboard/reports">
          <img
            :src="require('@/assets/img/Dashboard/reportesdark.png')"
            alt="reportes"
          />
        </router-link> -->
        <!-- <router-link class="flex-1 flex justify-center" to="/dashboard/charts">
          <img
            src="https://s3-sa-east-1.amazonaws.com/nirex2.0/Web+app/App_clientes/assets/Dashboard/iconos-mobile/m-reportes.svg"
            alt="charts"
          />
        </router-link> -->
        <router-link class="h-full group relative flex-1 flex justify-center" to="/dashboard/profile">
          <img src="@/assets/img/Icons/cuenta.png" alt="cliente" />
          <div class="mt-4 top-full group-hover hidden absolute pin-r w-full bg-cyan text-center py-2 z-50">
            <a class="text-dark-purple font-neue no-underline uppercase" @click="logout">Salir</a>
          </div>
        </router-link>
      </div>
    </div>
  </nav>
</template>
<script>

export default {
  methods: {
    logout() {
      this.$router.push("/auth/logout");
    },
  },
};
</script>
<style>
.link-visted:hover {
  color: #0A50E6;
}

.bg-cyan {
  background-color: #0A50E6;
}

.top-full {
  top: 100%;
}

.group:hover .group-hover {
  display: block;
}

.bg-navbar {
  background-color: white;
}

.nav-link {
  color: rgb(66, 82, 146);
}

.report__icon {
  filter: invert(460%) sepia(100%) saturate(20%);
}
</style>
